import React, {Fragment} from "react";
import PropTypes from "prop-types";

import Box from "@tds/core-box";
import Text from "@tds/core-text";

import {useLocalizedStringsContext} from "../../context/LocalizedStringsContext";

const DefectSummaryHeader = ({
                                 reportedOn,
                                 webForm,
                                 priority,
                                 status
                             }) => {
    const localizedString = useLocalizedStringsContext();
    const {
        DEFECT_MANAGEMENT: {DEFECT_TABLE: {REPORTED_ON, WEBFORM, PRIORITY, STATUS} = {}} = {}
    } = localizedString;

    return (
        <Fragment>
            <Box pb={12}>
                <Text bold color="#4B286D">
                    {REPORTED_ON}:{' '}
                </Text>
                <Text>{reportedOn}</Text>
            </Box>
            <Box pb={12}>
                <Text bold color="#4B286D">
                    {WEBFORM}:{' '}
                </Text>
                <Text>{webForm}</Text>
            </Box>
            <Box pb={12}>
                <Text bold color="#4B286D">
                    {PRIORITY}:{' '}
                </Text>
                <Text>{priority} </Text>
            </Box>
            <Box>
                <Text bold color="#4B286D">
                    {STATUS}:{' '}
                </Text>
                <Text>{status} </Text>
            </Box>
        </Fragment>
    );
};

DefectSummaryHeader.prototype = {
    reportedOn: PropTypes.string.isRequired,
    webForm: PropTypes.string.isRequired,
    priority: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
};

export default DefectSummaryHeader;
